module.exports = __webpack_public_path__ + "static/sport/bgi-form.0473873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/bgi-form.png
// module id = ldY2
// module chunks = 0